import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Customer } from '../interfaces/customer.model';
import * as moment from 'moment';
import icClose from '@iconify/icons-ic/twotone-close';
import icPrint from '@iconify/icons-ic/twotone-print';
import icDownload from '@iconify/icons-ic/twotone-cloud-download';
import icDelete from '@iconify/icons-ic/twotone-delete';
import icPhone from '@iconify/icons-ic/twotone-phone';
import icPerson from '@iconify/icons-ic/twotone-person';
import icMyLocation from '@iconify/icons-ic/twotone-my-location';
import icLocationCity from '@iconify/icons-ic/twotone-location-city';
import icEditLocation from '@iconify/icons-ic/twotone-edit-location';
import icDescription from '@iconify/icons-ic/twotone-description';
import { Observable } from 'rxjs';
import icVerticalSplit from '@iconify/icons-ic/twotone-vertical-split';
import icVisiblity from '@iconify/icons-ic/twotone-visibility';
import icVisibilityOff from '@iconify/icons-ic/twotone-visibility-off';
import icDoneAll from '@iconify/icons-ic/twotone-done-all';
import icMoreVert from '@iconify/icons-ic/twotone-more-vert';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { startWith, map, timeout, distinctUntilChanged } from 'rxjs/operators';
import { MatChipInputEvent } from '@angular/material/chips';
import { ThemePalette } from '@angular/material/core';
import { fadeInUp400ms } from '../../../../../../@vex/animations/fade-in-up.animation';
import { stagger40ms } from '../../../../../../@vex/animations/stagger.animation';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { JobsService } from '../../../../../../@vex/services/jobsService/jobs.service';
import { DepartmentService } from '../../../../../../@vex/services/departmentService/department.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { of } from 'rxjs';
import { ValidatorFn } from '@angular/forms';
import { fadeInRight400ms } from 'src/@vex/animations/fade-in-right.animation';
import { scaleIn400ms } from 'src/@vex/animations/scale-in.animation';
import { BackgroundService } from 'src/@vex/services/background.service';
import { Router } from '@angular/router';
import { JobListCreateUpdateComponent } from '../../../settings/recruiting-preference/custom-field/job-list/job-list-create-update/job-list-create-update.component';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { AppErrorStateMatcher } from 'src/app/shared/app-error-state-matcher';
import { CompanyInfoService } from 'src/@vex/services/companySettingService/companyInfo';
import { UserSettingService } from 'src/@vex/services/userSettingService/userSetting.service';
import { TranslateService } from '@ngx-translate/core';


@UntilDestroy()
@Component({
  selector: 'vex-job-approval-create-update',
  templateUrl: './job-approval-create-update.component.html',
  styleUrls: [
    './job-approval-create-update.component.scss',
    '../../../../../../../node_modules/quill/dist/quill.snow.css',
    '../../../../../../@vex/styles/partials/plugins/_quill.scss',
  ],

  encapsulation: ViewEncapsulation.None,
  animations: [fadeInUp400ms, stagger40ms],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
      } as MatFormFieldDefaultOptions,
    },
  ],
})
export class JobApprovalCreateUpdateComponent implements OnInit, AfterViewInit {

  public keyFormGroup: FormGroup;
  public locationFormGroup: FormGroup;
  public salaryFormGroup: FormGroup;
  public customFormGroup = new FormGroup({});
  public userFormGroup: FormGroup;
  public IsCheckedTandC: boolean;

  public templateFormGroup: FormGroup;

  approvalLevels = [
    {name: "1", value: 1},
    {name: "2", value: 2},
    {name: "3", value: 3},
    {name: "4", value: 4},
    {name: "5", value: 5},
    {name: "6", value: 6},
    {name: "7", value: 7},
    {name: "8", value: 9},
    {name: "9", value: 9},
    {name: "10", value: 10}
  ];
  phonePrefixOptions = ['+1', '+27', '+44', '+49', '+61', '+91'];
  jobtypeData: any = [];
  salTypeData: any = [];
  jobCurrencyData: any;
  jobCustomFeildData: any = [];
  passwordInputType = 'password';
  showJobDescriptionError = true;
  loginUserData;

  static id = 100;
  departmentData: any = [];
  form: FormGroup;
  mode: 'create' | 'update' = 'create';
  hiringManagerData: any = [];
  recruitersData: any = [];
  powerUserData: any = [];
  firstnamedata: any = [];
  icMoreVert = icMoreVert;

  icClose = icClose;
  recruiterNames: any = [];
  icDoneAll = icDoneAll;
  icDescription = icDescription;
  icVerticalSplit = icVerticalSplit;
  icVisibility = icVisiblity;
  icVisibilityOff = icVisibilityOff;
  icPrint = icPrint;
  icDownload = icDownload;
  icDelete = icDelete;

  icPerson = icPerson;
  icMyLocation = icMyLocation;
  icLocationCity = icLocationCity;
  icEditLocation = icEditLocation;
  icPhone = icPhone;
  // resourcesData = ELEMENT_RESOURCES_DATA;
  buisnessUnitData: any = [];
  minDate: Date = new Date();
  countriesData: any = [];
  filteredCountriesData: Observable<any[]>;
  stateData: any = [];
  filteredStateData: Observable<any[]>;
  companyData;
  canada;
  uk;
  us;
  // job keyword variable
  JKvisible = true;
  JKselectable = true;
  JKremovable = true;
  JKseparatorKeysCodes: number[] = [ENTER, COMMA];
  JKeywordCtrl = new FormControl();
  JKeywords: Observable<string[]>;
  keywords: string[] = [];
  allJobKeywords: string[] = [];

  @ViewChild('keywordInput') keywordInput: ElementRef<HTMLInputElement>;
  @ViewChild('autoKeyword') keywordMatAutocomplete: MatAutocomplete;
  @ViewChild('horizontalStepper') stepper: MatHorizontalStepper;


  // hiringManager
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  @ViewChild('hiringManagerInput') hiringManagerInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  // recruiters
  visible2 = true;
  selectable2 = true;
  removable2 = true;
  separatorKeysCodes2: number[] = [ENTER, COMMA];
  fruitCtrl2 = new FormControl();
  forms: FormGroup;
  recruitersOption: Observable<any>;
  groups: string[] = [];
  allRecruiters: any[] = [];
  AllPowerUsers: any[] = [];
  @ViewChild('groupInput') groupInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto2') matAutocomplete2: MatAutocomplete;

  allComplete: boolean = false;
  jobConfidentialData;
  jobTemplateData;
  jobKeywordData;
  Checkedval = '';

  matcher = new AppErrorStateMatcher();
  ordersData = [];

  keyword: any = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public defaults: any,
    private router: Router,
    private dialogRef: MatDialogRef<JobApprovalCreateUpdateComponent>,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private _jobService: JobsService,
    private _userSettingService: UserSettingService,
    private _departmentService: DepartmentService,
    private snackbar: MatSnackBar,
    public dialog: MatDialog,
    private translate: TranslateService,
    private _backgroundService: BackgroundService,
    private _companyInfoService: CompanyInfoService
  ) {
    this.getCompanyInfo();

    // this.templateFormGroup = this.fb.group({
    //   title: ['']
    // });
  }

  ngOnInit() {
    this.loginUserData = JSON.parse(localStorage.getItem('UserInfo'));
    if (this.defaults) {
      this.mode = 'update';
      this.keyword = this.defaults.jobkeyword != "" ? this.defaults.jobkeyword.split(',') : [];
      this.keywords = this.keyword;
    } else {
      this.defaults = {} as Customer;
    }

    this.keyFormGroup = this.fb.group({
      jobTitle: [this.defaults.Job_title ? this.defaults.Job_title : null, Validators.required],
      jobKeyword: [this.defaults.jobkeyword ? this.defaults.jobkeyword : null],
      buisnessUnit: [this.defaults.buid ? this.defaults.buid : null, Validators.required],
      department: [this.defaults.department ? this.defaults.department : null, Validators.required],
      // keyCountry: [null, Validators.required],
      // keyState: [null, Validators.required],
      jobDescription: ["", Validators.required],
      // requiredSkillExperience: [this.defaults.ReqSExp ? this.defaults.ReqSExp : ""],
      jobBenefit: [this.defaults.jobbenefit ? this.defaults.jobbenefit : ""],
    });

    this.keyFormGroup.controls.jobDescription.valueChanges.subscribe(data => {
      this.showJobDescriptionError = !data || data.replace("<p>").replace("</p>").length == 0;
    });

    if (this.defaults.jobdescription) {
      this.keyFormGroup.controls.jobDescription.setValue(this.defaults.jobdescription);
    }

    this.locationFormGroup = this.fb.group({
      owner: [this.defaults.jobowner ? this.defaults.jobowner : this.loginUserData.uid],
      locationCity: [this.defaults.city ? this.defaults.city : null, Validators.required],
      locationCountry: ['', Validators.required],
      locationState: ['', Validators.required],
      locationZip: [this.defaults.zip ? this.defaults.zip : null, Validators.required],
      locationAdditional: [this.defaults.joblocationstr ? this.defaults.joblocationstr : null],
    });
    
    this.salaryFormGroup = this.fb.group({
      salaryMin: [this.defaults.salary ? parseInt(this.defaults.salary.replace(/[^\d.-]/g, '')) : 50000, Validators.required],
      salaryMax: [this.defaults.salaryrange ? parseInt(this.defaults.salaryrange.replace(/[^\d.-]/g, '')) : 60000, [Validators.required, salaryValidator()]],
      salType: [this.defaults.salarytype ? this.defaults.salarytype : '0', Validators.required],
      salCurrency: [this.defaults.jobcurrency ? this.defaults.jobcurrency : 'USD', Validators.required]
    });

    this.customFormGroup = this.fb.group({});

    this.userFormGroup = this.fb.group({
      needApproval: ['Yes'],
      users: this.fb.array([
        this.fb.group({
          recruiter: ['', Validators.required],
          name: ['', Validators.required],
          email: ['',
            [
              Validators.email,
              Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$'),
              Validators.required
            ]
          ],
          approvalLevel: [1]
        })
      ]),
    });

    this.userFormGroup.controls.users.valueChanges.subscribe((value) => {
      value.forEach((element, index) => {
        if (element.recruiter && (this.users.at(index) as FormGroup).controls['name'].validator) {
          (this.users.at(index) as FormGroup).controls['recruiter'].setValidators([Validators.required]);
          (this.users.at(index) as FormGroup).controls['email'].setValidators([Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$')]);
          (this.users.at(index) as FormGroup).controls['name'].setValidators([]);
          (this.users.at(index) as FormGroup).controls['recruiter'].updateValueAndValidity();
          (this.users.at(index) as FormGroup).controls['email'].updateValueAndValidity();
          (this.users.at(index) as FormGroup).controls['name'].updateValueAndValidity();
        } else {
          if ((element.name || element.email) && (this.users.at(index) as FormGroup).controls['recruiter'].validator) {
            (this.users.at(index) as FormGroup).controls['recruiter'].setValidators([]);
            (this.users.at(index) as FormGroup).controls['email'].setValidators([Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$'), Validators.required]);
            (this.users.at(index) as FormGroup).controls['name'].setValidators([Validators.required]);
            (this.users.at(index) as FormGroup).controls['recruiter'].updateValueAndValidity();
            (this.users.at(index) as FormGroup).controls['email'].updateValueAndValidity();
            (this.users.at(index) as FormGroup).controls['name'].updateValueAndValidity();
          }
        }
      });
    });

    this._jobService.getJobKeyword().subscribe((data) => {
      this.jobKeywordData = data;
      window.allJobKeywords = this.jobKeywordData;
      if (window.allJobKeywords) {
        this.JKeywords = this.keyFormGroup.controls.jobKeyword.valueChanges.pipe(
          startWith(null),
          map((fruit: string | null) =>
            fruit ? this._filterKeyword(fruit) : window.allJobKeywords.slice()
          )
        );
      }
    });

    this.locationFormGroup.controls['locationCountry'].valueChanges.subscribe(value => {
      if (!value || value == '' || value == ' ') {
        var tempCountries = this.countriesData;
        const indexOfUSA = tempCountries.findIndex(country => country.iso == 'USA');
        tempCountries.slice(indexOfUSA, 1);
        tempCountries.sort(function(a, b) 
        {
          var nameA = a.name.toUpperCase();
          var nameB = b.name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        tempCountries.unshift({ iso: 'USA', name: 'United States' });
        this.filteredCountriesData = tempCountries;
      } else {
        this.filteredCountriesData = this.countriesData.filter(option => option.name.toLowerCase().includes(value.toLowerCase()));
        const country = this.countriesData.find(country => country.name.toLowerCase() == value.toLowerCase());
        if (country) {
          this.getState(country.iso);
        }
      }
    });
    this.locationFormGroup.controls['locationState'].valueChanges.subscribe(value => {
      this.filteredStateData = this.stateData.filter(option => option.name.toLowerCase().includes(value.toLowerCase()));
    });
    this.getCountries();
    this.getJobTypeData();
    this.getSalaryRangeData();
    this.getRecruitTeamMember();
    this.getPowerUsersData();
    this.getBusinessUnitData();
    this.getJobKeywordData();
    this.getSalTypeData();
    this.getJobCurrencyData();
    this.getCustomFieldsData();

    this.getJobTemplates();

    if (this.defaults.buid) {
      this.getDepartmentData(this.defaults.buid);
    }
  }

  ngAfterViewInit() {
    
  }

  get users() {
    return this.userFormGroup.controls["users"] as FormArray;
  }

  addUser() {
    const userForm = this.fb.group({
        recruiter: ['', Validators.required],
        name: ['', Validators.required],
        email: ['',
          [
            Validators.email,
            Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$'), 
            Validators.required
          ]
        ],
        approvalLevel: [this.users.length + 1]
    });
    this.users.push(userForm);
  }

  deleteUser(lessonIndex: number) {
    this.users.removeAt(lessonIndex);
  }

  next() {
    this.stepper.next();    
  }

  getCompanyInfo() {
    this._companyInfoService.getCompanyInfo().subscribe((data) => {
      this.companyData = data;

      if (this.countriesData && this.mode === 'create') {
        this.toggleAddress();
      }
    })
  }

  toggleAddress() {
    if (!this.companyData) { return; }
    
    this.locationFormGroup.controls.locationCity.setValue(this.companyData.city);
    this.locationFormGroup.controls.locationZip.setValue(this.companyData.postalCode);
    this.locationFormGroup.controls.locationAdditional.setValue(this.companyData.address1);

    const country = this.countriesData.find(country => country.name == this.companyData.country);
    if (country) {
      this.locationFormGroup.controls.locationCountry.setValue(country.name);

      setTimeout(() => {
        this._jobService.getStateData(country.iso).subscribe((res) => {
          const stateData: any[] = res.data;
          const state = stateData.find(state => state.name == this.companyData.state);
          if (state) {
            this.locationFormGroup.controls.locationState.setValue(state.name);
          }
        });
      }, 1000);
    }
  }

  getCountries() {
    this._jobService.getCountriesData().subscribe((data) => {
      var countries = data['data'];

      // find and remove USA
      const indexOfUSA = countries.findIndex(country => country.iso == 'USA');
      if (indexOfUSA >= 0) {
        countries.splice(indexOfUSA, 1);
      }

      this.countriesData = countries;      
      
      // add USA at the beginning of the array
      this.countriesData.unshift({ iso: 'USA', name: 'United States' });
      this.filteredCountriesData = data['data'];

      if (this.mode === 'create') {
        this.toggleAddress();

      } else {
        const country = this.countriesData.find(country => country.iso == this.defaults.country);
        if (country) {
          this.locationFormGroup.controls['locationCountry'].setValue(country.name);
        } else {
          this.locationFormGroup.controls['locationCountry'].setValue('');
          this.locationFormGroup.controls['locationState'].setValue('');
        }
      }
    });
  }

  getStateByName(e) {
    const country = this.countriesData.filter(country => country.name.toLowerCase() == e.option.value.toLowerCase());
    this._jobService.getStateData(country[0].iso).subscribe((res) => {
      this.stateData = res.data;
      if (this.locationFormGroup.controls['locationState'].value) {
        const state = this.stateData.find(state => state.name.toLowerCase() == this.locationFormGroup.controls['locationState'].value.toLowerCase());
        if (!state) {
          this.locationFormGroup.controls['locationState'].setValue('');
        }
      } else {
        this.filteredCountriesData = res.data;
      }
    });
  }

  getState(countryId) {
    this._jobService.getStateData(countryId).subscribe((res) => {
      this.stateData = res.data;
      this.filteredStateData = res.data;
      const state = this.stateData.find(state => {
        if (this.locationFormGroup.controls['locationState'].value) {
          return state.name.toLowerCase() == this.locationFormGroup.controls['locationState'].value.toLowerCase();
        } else {
          return state.iso == this.defaults.state || this.defaults.JTstate || '';
        }
      });
      if (!state) {
        this.locationFormGroup.controls['locationState'].setValue('');
      } else {
        this.locationFormGroup.controls['locationState'].setValue(state.name);
      }
    });
  }

  // country autocomplete trigger panel is closed
  // clear input to only let the user select a country from the list
  public onCountryOptionPanelClosed() {
    const countries = this.countriesData.filter(country => country.name.toLowerCase() == this.locationFormGroup.value.locationCountry.toLowerCase());
    if (countries.length <= 0) {
      this.locationFormGroup.controls.locationCountry.setValue('');
      
    } else {
      this.locationFormGroup.controls.locationCountry.setValue(countries[0].name);
    }
  }

  // state autocomplete selection closed
  // clear input to only let the user select a state from the list
  public onStateOptionPanelClosed() {
    const states = this.stateData.filter(state => state.name.toLowerCase() == this.locationFormGroup.value.locationState.toLowerCase());

    if (states.length <= 0) {
      this.locationFormGroup.controls.locationState.setValue('');

    } else {
      this.locationFormGroup.controls.locationState.setValue(states[0].name);
    }
  }

  save() {
    if (this.mode === 'create') {
      this.createCustomer();
    } else if (this.mode === 'update') {
      this.updateCustomer();
    }
  }

  createCustomer() {
    if (this.keyFormGroup.invalid) {
      return false;
    } else if (this.locationFormGroup.invalid) {
      return false;
    } else {
      const customData = {
        customID: '',
        custID_noFvalue: ''
      };
      const existingCustIDs = this.defaults.cfvalue ? this.defaults.cfvalue.map(value => value.CustID) : null;
      existingCustIDs ? this.jobCustomFeildData.forEach((x, i) => {
        if (this.customFormGroup.controls[x.customFieldID].value) {
          customData.customID = customData.customID + (customData.customID.length == 0 ? '' : ',') + x.customFieldID
          existingCustIDs.includes(x.customFieldID) ? null : customData.custID_noFvalue = customData.custID_noFvalue + (customData.custID_noFvalue.length == 0 ? '' : ',') + x.customFieldID;
          if (x.customFieldType === 2) {
            const values = [];
            var custom = '';
            this.customFormGroup.controls[x.customFieldID].value.forEach((element, j) => {
              element ? values.push(x.selectFromValue[j]) : null;
            });
            values.forEach((value, k) => {
              custom = custom + (k == 0 ? '' : ',') + value;
            })
            customData[`cfvalue_${x.customFieldID}`] = custom;
          } else {
            customData[`cfvalue_${x.customFieldID}`] = this.customFormGroup.controls[x.customFieldID].value;
          }
        }
      }) : null;

      const country = this.countriesData.filter(country => country.name.toLowerCase() == this.locationFormGroup.value.locationCountry.toLowerCase());
      const state = this.stateData.filter(state => state.name.toLowerCase() == this.locationFormGroup.value.locationState.toLowerCase());
      
      if (!this.isApprovalValid()) {
        return;
      }

      var jobApprovalData = { jobneedapproval: 0 };
      if (this.userFormGroup.controls.needApproval.value === 'Yes') {        
        jobApprovalData['jobneedapproval'] = 1;
        jobApprovalData['applist'] = this.userFormGroup.controls.users.value.length;
        
        this.userFormGroup.controls.users.value.map((user, index) => {
          jobApprovalData[`appmust_${index + 1}`] = 1;
          
          if (user.recruiter !== "") {
            const recruiter = this.allRecruiters.find(item => item.recruiter_id == user.recruiter);

            jobApprovalData[`applevel_${index + 1}`] = user.approvalLevel;
            jobApprovalData[`recruitteam_${index + 1}`] = `${recruiter.recruiter_id}~~${recruiter.Name}^^${recruiter.email}`;
            jobApprovalData[`appemail_${index + 1}`] = recruiter.email;

          } else {
            jobApprovalData[`applevel_${index + 1}`] = user.approvalLevel;
            jobApprovalData[`appname_${index + 1}`] = user.name;
            jobApprovalData[`appemail_${index + 1}`] = user.email;
          }
        })
      }

      const jobApprovalBody = {
        "expiredate": '', // this.dateFormGroup.value.internalCarrerHosting,
        "job_title": this.keyFormGroup.value.jobTitle,
        "jobdescription": this.keyFormGroup.value.jobDescription,
        "salary": this.salaryFormGroup.value.salaryMin,
        "salmax": this.salaryFormGroup.value.salaryMax,
        "saltype": this.salaryFormGroup.value.salType,
        "department": this.keyFormGroup.value.department,
        "zip": this.locationFormGroup.value.locationZip,
        "country": country[0].iso,
        "state": state[0].iso,
        "city": this.locationFormGroup.value.locationCity,
        "reqsexp": this.keyFormGroup.value.jobDescription, // this.keyFormGroup.value.requiredSkillExperience,
        "jobkeyword": this.keywords.join(),
        "jobbenefit": this.keyFormGroup.value.jobBenefit,
        "salcurrency": this.salaryFormGroup.value.salCurrency,
        "joblocationstr": this.locationFormGroup.value.locationAdditional,
        "recruiter": this.locationFormGroup.value.owner,
        // "template_title": this.templateFormGroup.value.title,
        ...customData,
        ...jobApprovalData
      }


      this._backgroundService.showLoading();
      this._jobService.jobApprovalCreation(jobApprovalBody).subscribe((data) => {
        this._backgroundService.hideLoading();
        if (data['message'] === 'Success') {
          this.snackbar.open(this.translate.instant('SUCCESS'), this.translate.instant('JOB_APPROVAL_POSTED_SUCCESSFULLY'), {
            duration: 1500,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
          this.dialogRef.close();
        } else {
          this.snackbar.open(this.translate.instant('FAIL'), this.translate.instant('JOB_APPROVAL_POST_FAILED_TRY_AGAIN'), {
            duration: 1500,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }
      }, (err) => {
        this._backgroundService.hideLoading();
        this.snackbar.open(this.translate.instant('FAIL'), this.translate.instant('JOB_APPROVAL_POST_FAILED_TRY_AGAIN'), {
          duration: 1500,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
        console.log(err);
      });
    }
  }

  updateCustomer() {
    const customData = {
      customID: '',
      custID_noFvalue: ''
    };
    const existingCustIDs = this.defaults.cfvalue.map(value => value.CustID);
    this.jobCustomFeildData.forEach((x, i) => {
      if (this.customFormGroup.controls[x.customFieldID].value) {
        customData.customID = customData.customID + (customData.customID.length == 0 ? '' : ',') + x.customFieldID
        existingCustIDs.includes(x.customFieldID) ? null : customData.custID_noFvalue = customData.custID_noFvalue + (customData.custID_noFvalue.length == 0 ? '' : ',') + x.customFieldID;
        if (x.customFieldType === 2) {
          const values = [];
          var custom = '';
          this.customFormGroup.controls[x.customFieldID].value.forEach((element, j) => {
            element ? values.push(x.selectFromValue[j]) : null;
          });
          values.forEach((value, k) => {
            custom = custom + (k == 0 ? '' : ',') + value;
          })
          customData[`cfvalue_${x.customFieldID}`] = custom;
        } else {
          customData[`cfvalue_${x.customFieldID}`] = this.customFormGroup.controls[x.customFieldID].value;
        }
      }
    });

    const country = this.countriesData.filter(country => country.name.toLowerCase() == this.locationFormGroup.value.locationCountry.toLowerCase());
    const state = this.stateData.filter(state => state.name.toLowerCase() == this.locationFormGroup.value.locationState.toLowerCase());

    if (!this.isApprovalValid()) {
      return;
    }

    const jobApprovalData = { jobneedapproval: 0 };
    if (this.userFormGroup.controls.needApproval.value === 'Yes') {
      jobApprovalData['jobneedapproval'] = 1;
      jobApprovalData['applist'] = this.userFormGroup.controls.users.value.length;
      this.userFormGroup.controls.users.value.map((user, index) => {
        jobApprovalData[`appmust_${index + 1}`] = 1;
        if (user.recruiter !== "") {
          const recruiter = this.allRecruiters.find(item => item.UID == user.recruiter);
          jobApprovalData[`applevel_${index + 1}`] = user.approvalLevel;
          jobApprovalData[`recruitteam_${index + 1}`] = `${recruiter.UID}~~${recruiter.Name}^^${recruiter.email}`;
          jobApprovalData[`appemail_${index + 1}`] = recruiter.email;
        } else {
          jobApprovalData[`applevel_${index + 1}`] = user.approvalLevel;
          jobApprovalData[`appname_${index + 1}`] = user.name;
          jobApprovalData[`appemail_${index + 1}`] = user.email;
        }
      })
    }

    const jobBody = {
      "jid": this.defaults.JID,
      "job_title": this.keyFormGroup.value.jobTitle,
      "jobdescription": this.keyFormGroup.value.jobDescription,
      "salary": this.salaryFormGroup.value.salaryMin,
      "salmax": this.salaryFormGroup.value.salaryMax,
      "saltype": this.salaryFormGroup.value.salType,
      "department": this.keyFormGroup.value.department,
      "zip": this.locationFormGroup.value.locationZip,
      "country": country[0].iso,
      "state": state[0].iso,
      "City": this.locationFormGroup.value.locationCity,
      "reqsexp": this.keyFormGroup.value.jobDescription, // this.keyFormGroup.value.requiredSkillExperience,
      "jobkeyword": this.keywords.join(),
      "STATUS": 1,
      "jobbenefit": this.keyFormGroup.value.jobBenefit,
      "salcurrency": this.salaryFormGroup.value.salCurrency,
      "joblocationstr": this.locationFormGroup.value.locationAdditional,
      "recruiter": this.locationFormGroup.value.owner,
      // "template_title": this.templateFormGroup.value.title,
      ...customData,
      ...jobApprovalData
    }
    

    this._backgroundService.showLoading();
    this._jobService.jobApprovalUpdate(jobBody).subscribe((data) => {
      this._backgroundService.hideLoading();
      if (data['message'] === 'Success') {
        this.snackbar.open(this.translate.instant('SUCCESS'), this.translate.instant('JOB_APPROVAL_UPDATED_SUCCESSFULLY'), {
          duration: 1500,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
        this.dialogRef.close();
      } else {
        this.snackbar.open(this.translate.instant('FAIL'), this.translate.instant('JOB_APPROVAL_UPDATE_FAILED_TRY_AGAIN'), {
          duration: 1500,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      }
    }, (err) => {
      this._backgroundService.hideLoading();
      this.snackbar.open(this.translate.instant('FAIL'), this.translate.instant('JOB_APPROVAL_UPDATE_FAILED_TRY_AGAIN'), {
        duration: 1500,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
      // console.log(err);
    });

  }

  isCreateMode() {
    return this.mode === 'create';
  }

  isUpdateMode() {
    return this.mode === 'update';
  }
  // job keyword
  addKeyword(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our keyword

    if ((value || '').trim()) {
      if (!this.keywords.includes(value.trim())) {
        this.keywords.push(value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.keyFormGroup.controls.jobKeyword.setValue(null);

  }

  removeKeyword(keyword: string): void {
    const index = this.keywords.indexOf(keyword);
    if (index >= 0) {
      this.keywords.splice(index, 1);
    }
  }

  selectedKeyword(event: MatAutocompleteSelectedEvent): void {
    this.keywords.push(event.option.viewValue);
    this.keywordInput.nativeElement.value = '';
    this.keyFormGroup.controls.jobKeyword.setValue(null);
  }

  private _filterKeyword(value: string): string[] {
    const filterValue = value.toLowerCase();
    return window.allJobKeywords.filter(fruit => fruit.HotbookName.toLowerCase().indexOf(filterValue) === 0);

  }

  createCustomField() {
    this.dialog
      .open(JobListCreateUpdateComponent, {
        width: "100%",
      })
      .afterClosed()
      .subscribe(() => {
        this.getCustomFieldsData();
      });
  }

  // Job Creations Get endpoints start

  getSalaryRangeData() {
    this._jobService.getSalaryRange().subscribe(e => {
    });
  }
  getBusinessUnitData() {
    this._departmentService.getBusinessUnitData().subscribe((data) => {
      this.buisnessUnitData = data['data'];
    });
  }

  getDepartmentData(id) {
    this._departmentService.getDepartment(id).subscribe((response) => {
      this.departmentData = response['data'];
    });
  }

  getPowerUsersData() {
    this._jobService.getPowerUsersData().subscribe((data) => {
      const allUsers: any = data;
      this.AllPowerUsers = allUsers.filter(item => item.role == 5 || item.role == 7 || item.role == 9);
    });
  }
  getRecruitTeamMember() {
    this._userSettingService.getRecruitTeamMember().subscribe((data) => {
      const recruiters: any = data;
      this.allRecruiters = recruiters;
    });
  }
  getJobKeywordData() {
    this._jobService.getJobKeyword().subscribe((data) => {
      this.jobKeywordData = data;
      window.jobKeywordData = data;
    });
  }
  getJobTypeData() {
    this._jobService.getJobTypeData().subscribe((data) => {
      this.jobtypeData = data;
    });
  }
  getSalTypeData() {
    this._jobService.getSalType().subscribe((data) => {
      this.salTypeData = data;
    });
  }
  getJobCurrencyData() {
    this._jobService.getJobCurrency().subscribe((data) => {
      this.jobCurrencyData = data;
    });
  }
  getCustomFieldsData() {
    this._jobService.getCustomFields().subscribe((res) => {
      this.jobCustomFeildData = res.data;
      this.jobCustomFeildData.forEach(x => {
        const customField = this.defaults.cfvalue ? this.defaults.cfvalue.find((element => element.CustID == x.customFieldID)) : null;
        if (x.customFieldType === 0) {
          this.customFormGroup.addControl(x.customFieldID, new FormControl(customField ? customField.Fvalue : ''));
        }
        if (x.customFieldType === 1) {
          this.customFormGroup.addControl(x.customFieldID, new FormControl(customField ? customField.Fvalue : ''));
        }
        if (x.customFieldType === 2) {
          this.customFormGroup.addControl(x.customFieldID, this.fb.array(x.selectFromValue.map(value => customField ? customField.Fvalue.indexOf(value) > -1 : !1)));
        }
        if (x.customFieldType === 3) {
          this.customFormGroup.addControl(x.customFieldID, new FormControl(customField ? customField.Fvalue : ''));
        }
      });
    });
  }

  private getJobTemplates() {
    this._jobService.getJobTemplate().subscribe((response) => {
      this.jobTemplateData = response;
    });
  }

  getJobTemplate(id) {
    const selected = this.jobTemplateData.find(item => item.JTemplateID === id);
    if(selected) {
      this.defaults = selected;

      this.keywords = this.defaults.Keyword != "" ? this.defaults.Keyword.split(',') : [];

      // prefill key form
      this.keyFormGroup.patchValue({
        jobTitle: this.defaults.TemplateTitle ?? '', 
        jobKeyword: this.defaults.Keyword != "" ? this.defaults.keyword : null,
        buisnessUnit: this.defaults.BUID ?? '',
        department: this.defaults.Tdepid, 
        jobDescription: this.defaults.TDescription, 
        jobBenefit: this.defaults.JTbenefit
      });

      if (this.defaults.BUID) {
        this.getDepartmentData(this.defaults.BUID);
      }

      this.keyFormGroup.controls.jobDescription.valueChanges.subscribe(data => {
        this.showJobDescriptionError = !data || data.replace("<p>").replace("</p>").length == 0;
      });

      // prefill location form
      this.locationFormGroup.patchValue({
        locationCity: this.defaults.JTcity,
        locationCountry: '', 
        locationState: '',
        locationZip: this.defaults.JTZip,
        locationAdditional: this.defaults.JTjoblocation
      });

      if (this.countriesData.length > 0) {
        const country = this.countriesData.find(country => country.iso == this.defaults.JTcountry);

        if (country) {
          this.locationFormGroup.controls.locationCountry.setValue(country.name);

          // this.getState(country.iso);
        }
      }

      // prefill salary form
      this.salaryFormGroup.patchValue({
        salaryMin: this.defaults.salary ? parseInt(this.defaults.salary.replace(/[^\d.-]/g, '')) : 50000, 
        salaryMax: this.defaults.JTsalaryrange ? parseInt(this.defaults.JTsalaryrange.replace(/[^\d.-]/g, '')) : 60000, 
        salType: this.defaults.JTsaltype ? this.defaults.JTsaltype : '0',
        salCurrency: this.defaults.JTsalarycurrency ? this.defaults.JTsalarycurrency : 'USD'
      });
    }
  }

  onRequireApprovalChanged(value) {
    if (value === 'Yes') {
      this.addUser();
      
    } else {
      // Do not initialize, value changes observer will not work
      (this.userFormGroup.controls.users as FormArray).clear(); // = this.fb.array([]);
    }
  }

  isApprovalValid(): boolean {
    if (this.userFormGroup.value.needApproval === 'Yes') {
      return this.userFormGroup.valid && this.users.valid

    } else {
      return true;
    }    
  }
}

function salaryValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return !!control.parent && !!control.parent.value && Number(control.value) < Number((control.parent?.controls as any)['salaryMin'].value) ? { wrongSalary: true } : null;
  };
}

// export const recruiterValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
//   if (!control.parent || !control) {
//     return null;
//   }

//   const name = control.parent.get('name');
//   const email = control.parent.get('email');

//   if (name.hasError('required') && email.hasError('required')) {
//     if (control.hasError('required')) {
//       console.log('required');
//       return { 'required': true };
//     }
//   }

//   console.log('null');

//   return null;
// }

// export const approverValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
//   const recruiter = control.get('recruiter')?.value;
//   const name = control.get('name')?.value;
//   const email = control.get('email')?.value;

//   return null;
// };

// function userValidator(): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     return !!control.parent && !!control.parent.value && !control.value && (control.parent?.controls && (!(control.parent?.controls as any)['name'].value || !(control.parent?.controls as any)['email'].value)) ? { required: true } : null;
//   };
// }

// function nameValidator(): ValidatorFn {
//   return (control: AbstractControl): ValidationErrors | null => {
//     return !!control.parent && !!control.parent.value && !control.value && (control.parent?.controls && (!(control.parent?.controls as any)['name'].value || !(control.parent?.controls as any)['email'].value)) ? { required: true } : null;
//   };
// }